<div class="app-work-item-preview">
  <app-preview-header [workItemId]="workItemId"
                      [workItemType]="workItemType"
                      (closeAction)="closeButtonClicked()">
  </app-preview-header>
  <div class="preview-lanes">
    <app-chat-viewer
      *ngIf="isChat && isWorkItemPreviewVisible"
      [chatId]="workItemId"
      [tabName]="tabName"
      (closeAction)="closeButtonClicked()">
    </app-chat-viewer>
    <app-email-thread-preview
      *ngIf="isEmail"
      [emailThreadId]="workItemId"
      (closeAction)="closeButtonClicked()">
    </app-email-thread-preview>
    <app-messaging-preview
      *ngIf="isMessaging && isWorkItemPreviewVisible"
      [messagingId]="workItemId"
      [messagingType]="workItemType"
      [tabName]="tabName"
      (closeAction)="closeButtonClicked()">
    </app-messaging-preview>
    <app-detailed-data class="detailed-data bc-panel" [workItemId]="workItemId" [workItemType]="workItemType" *ngIf="(isChat || isMessaging) && isDetailedDataVisible">
    </app-detailed-data>
    <div class="bc-panel bc-work-item-theme" [ngClass]="themeClass" *ngIf="(isChat || isMessaging) && isVisitorHistoryVisible">
      <div class="history-wrapper">
        <app-assignment-history *ngIf="hasAssignmentHistoryPermission" class="bc-panel"
                                [chatId]="isChat ? workItemId : null"
                                [textChatId]="isMessaging ? workItemId : null"
                                [isItemClosed]="isClosed"
                                [attr.data-automation-id]="'ASSIGNMENT_HISTORY_PANEL'">
        </app-assignment-history>
        <app-visitor-history class="visitor-history"
                             [chatId]="isChat ? workItemId : null"
                             [textChatId]="isMessaging ? workItemId : null"
                             [showOldestFirst]="true"
                             [tabName]="tabName">
        </app-visitor-history>
      </div>
    </div>
  </div>
</div>
